'use client';

import React from 'react';
import moment from 'moment';
import 'moment/locale/zh-cn';

moment.locale('zh-cn');

const SiteMoment = () => {
  return null;
};
export default SiteMoment;
